import React, { useState } from "react";
import { ThemeProvider } from "@material-ui/styles";
import theme from "./theme";
import { CssBaseline } from "@material-ui/core";
import {
  Route,
  Switch,
  Redirect,
  BrowserRouter as Router,
  RouteProps,
} from "react-router-dom";
import AuthContainer from "./containers/Auth/AuthContainer";
import DashboardContainer from "./containers/Dashboard/DashboardContainer";
import { Helmet } from "react-helmet";
import { useAuthState } from "./hooks/useAuthState";

export interface ProtectedRouteProps extends RouteProps {
  authState: boolean;
}

export class ProtectedRoute extends Route<ProtectedRouteProps> {
  public render() {
    let redirectPath: string = "";
    if (!this.props.authState) redirectPath = "/auth";

    if (redirectPath) {
      const renderComponent = () => (
        <Redirect to={{ pathname: redirectPath }} />
      );
      return (
        <Route {...this.props} component={renderComponent} render={undefined} />
      );
    } else {
      return <Route {...this.props} />;
    }
  }
}

const App: React.FC = () => {
  const [authState, setAuth] = useAuthState();

  return (
    <>
      <Helmet>{/* Add header things here */}</Helmet>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Switch>
            <Route
              exact
              path="/auth"
              render={r => <AuthContainer setAuth={setAuth} {...r} />}
            />
            <ProtectedRoute
              authState={authState}
              exact
              path="/dashboard"
              render={r => (
                <DashboardContainer {...r} setAuth={setAuth} view="dashboard" />
              )}
            />
            <ProtectedRoute
              authState={authState}
              exact
              path="/cameras"
              render={r => (
                <DashboardContainer {...r} setAuth={setAuth} view="cameras" />
              )}
            />
            <ProtectedRoute
              authState={authState}
              exact
              path="/settings"
              render={r => (
                <DashboardContainer {...r} setAuth={setAuth} view="settings" />
              )}
            />
            <ProtectedRoute
              authState={authState}
              exact
              path="/camerasv2"
              render={r => (
                <DashboardContainer {...r} setAuth={setAuth} view="camerasv2" />
              )}
            />
            <ProtectedRoute
              authState={authState}
              exact
              path="/testing"
              render={r => (
                <DashboardContainer {...r} setAuth={setAuth} view="testing" />
              )}
            />
            <Redirect to={"/dashboard"} />
            {/* <Route component={() => <div>404</div>} /> */}
          </Switch>
        </Router>
      </ThemeProvider>
    </>
  );
};

export default App;
